import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Table, Tag, Tabs, Popconfirm, DatePicker, Checkbox, Modal, Tooltip} from "antd";
import Colors from "../../../styles/Colors";
import {BiPlus, BiRefresh, BiTrash, BiPencil, BiCheck, BiDownArrowAlt} from "react-icons/bi";
import {BsBoxSeam, BsTruck, BsInboxes} from "react-icons/bs";
import {QuestionCircleOutlined} from "@ant-design/icons";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {GetStock} from "../../../dao/menudesign/GetStock";
import Stock from "../../../model/menudesign/Stock";
import StockModal from './components/StockModal';
import {GetIngredients} from "../../../dao/menudesign/GetIngredients";
import Ingredient from '../../../model/menudesign/Ingredient';
import {DeleteStock} from '../../../dao/menudesign/DeleteStock';
import {
    GetGestioStock, PostGestioStock, DeleteGestioStock, GetProductesGestioStock, PostProducteLliurat,
    GetComandesPendentsRebre, DeleteComandaPendentRebre, MoveComandaToStock
} from "../../../dao/menudesign/StockGestio";
import dayjs, {Dayjs} from "dayjs";
import toast, {Toaster} from "react-hot-toast";

const {RangePicker} = DatePicker;

// ============ PESTANYA 1: Gestió Stock Magatzem ============
const StockMagatzem: React.FC = () => {
    const {user, page} = useContext(AuthContext);
    const nomPermis = "Gestió Stock";
    const permisosEdicio = user.pagines.some((p: any) => p.descripcio === nomPermis && p.tipus === 1);

    const [coleccio, setDades] = useState<Stock[]>([]);
    const [ingredients, setIngredients] = useState<Ingredient[]>([]);
    const [editable, setEditable] = useState(false);
    const [elementSelected, setElementSelected] = useState<Stock>(new Stock());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);

    useEffect(() => { checkDades(); /* eslint-disable-next-line */ }, []);

    async function checkDades() {
        setLoading(true);
        const dades = await GetStock(page);
        setDades(Array.isArray(dades) ? dades : []);
        setNomFiltres((dades || []).map((e: Stock) => ({text: e.nom, value: e.nom})));
        const ing = await GetIngredients(page);
        setIngredients(ing || []);
        setLoading(false);
    }

    async function deleteElement(id: number) {
        await DeleteStock(id, page);
        await checkDades();
    }

    function afegirElement(element: Stock) {
        setEditable(true);
        setNouElement(true);
        setElementSelected(element);
    }

    function editarElement(element: Stock) {
        setEditable(false);
        setNouElement(true);
        setElementSelected(element);
    }

    const columns: ColumnsType<Stock> = [
        {key: 'id', title: 'ID', dataIndex: 'id', width: 60, responsive: ['lg'], sorter: (a, b) => a.id - b.id},
        {
            key: 'nom', title: 'Nom', dataIndex: 'nom',
            filterSearch: true, filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {key: 'quantitat', title: 'Quantitat', dataIndex: 'quantitat', width: 120},
        {
            key: 'mesura', title: 'Mesura', dataIndex: 'mesura', width: 120,
            render: (_, ele) => <Tag color={Colors.colors.color5}>{ele.mesura}</Tag>
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 140,
            render: (_, ele) => permisosEdicio ? (
                <div style={{display: 'flex', gap: 6}}>
                    <Button title="Editar" style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => editarElement(ele)}><BiPencil/></Button>
                    <Popconfirm title="Eliminar" description="Vols eliminar aquest ingredient del stock?"
                                onConfirm={() => deleteElement(ele.id)}
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}>
                        <Button title="Eliminar" style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>
                </div>
            ) : null,
        },
    ];

    return (
        <>
            <div style={{display: 'flex', gap: 8, marginBottom: 12}}>
                {permisosEdicio &&
                    <Button title="Nou ingredient a stock" style={{backgroundColor: Colors.colors.color2}}
                            onClick={() => afegirElement(new Stock())}><BiPlus/></Button>}
                <Button title="Refrescar" style={{backgroundColor: Colors.colors.color4}}
                        onClick={checkDades}><BiRefresh/></Button>
            </div>
            <Table loading={loading} columns={columns} dataSource={coleccio} rowKey="id" pagination={{pageSize: 50}}/>
            {nouElement && (
                <StockModal element={elementSelected} onClose={() => {setNouElement(false); checkDades();}}
                            visible={nouElement} ingredients={ingredients} editable={editable} page={page}/>
            )}
        </>
    );
};

// ============ PESTANYA 2: Comandes a lliurar (escoles) ============
const ComandesLliurar: React.FC = () => {
    const {page} = useContext(AuthContext);
    const [gestions, setGestions] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [rang, setRang] = useState<[Dayjs, Dayjs] | null>(null);

    // Modal de validació de productes
    const [validantId, setValidantId] = useState<number | null>(null);
    const [productes, setProductes] = useState<any[]>([]);
    const [loadingProd, setLoadingProd] = useState(false);

    useEffect(() => { carregar(); /* eslint-disable-next-line */ }, []);

    async function carregar() {
        setLoading(true);
        setGestions(await GetGestioStock(page));
        setLoading(false);
    }

    async function crearGestio() {
        if (!rang || !rang[0] || !rang[1]) {
            toast.error("Selecciona un rang de dates");
            return;
        }
        const ok = await PostGestioStock(page, rang[0].format('YYYY-MM-DD'), rang[1].format('YYYY-MM-DD'));
        if (ok) { toast.success("Gestió creada"); setRang(null); carregar(); }
        else toast.error("Error en crear la gestió");
    }

    async function eliminar(id: number) {
        const ok = await DeleteGestioStock(page, id);
        if (ok) { toast.success("Eliminada"); carregar(); }
        else toast.error("Error en eliminar");
    }

    async function obrirValidacio(id: number) {
        setValidantId(id);
        setLoadingProd(true);
        setProductes(await GetProductesGestioStock(page, id));
        setLoadingProd(false);
    }

    async function toggleLliurat(prod: any) {
        if (validantId === null) return;
        const nouLliurat = prod.lliurat === 1 ? 0 : 1;
        const ok = await PostProducteLliurat(
            page, validantId, prod.id_ingredient, prod.id_escola, prod.quantitat, nouLliurat
        );
        if (ok) {
            setProductes(prev => prev.map(p =>
                (p.id_ingredient === prod.id_ingredient && p.id_escola === prod.id_escola)
                    ? {...p, lliurat: nouLliurat} : p
            ));
        } else {
            toast.error("Error en actualitzar el lliurament");
        }
    }

    const columns: ColumnsType<any> = [
        {key: 'id', title: 'ID', dataIndex: 'id', width: 60, sorter: (a, b) => a.id - b.id},
        {
            key: 'inici', title: "Inici", dataIndex: 'inici', width: 130,
            render: (v) => <Tag>{v ? dayjs(v).format('DD-MM-YYYY') : '-'}</Tag>
        },
        {
            key: 'fin', title: 'Fin', dataIndex: 'fin', width: 130,
            render: (v) => <Tag>{v ? dayjs(v).format('DD-MM-YYYY') : '-'}</Tag>
        },
        {
            key: 'estat', title: 'Estat', dataIndex: 'estat', width: 140,
            render: (v) => v === 1
                ? <Tag color="green">Lliurat parcial/total</Tag>
                : <Tag color="orange">Pendent</Tag>
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 160,
            render: (_, ele) => (
                <div style={{display: 'flex', gap: 6}}>
                    <Tooltip title="Validar lliuraments">
                        <Button style={{backgroundColor: Colors.colors.color2, color: '#fff'}}
                                icon={<BiCheck/>} onClick={() => obrirValidacio(ele.id)}/>
                    </Tooltip>
                    <Popconfirm title="Eliminar" description="Vols eliminar aquesta gestió?"
                                onConfirm={() => eliminar(ele.id)}
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}>
                        <Button style={{backgroundColor: Colors.colors.color5}} icon={<BiTrash/>}/>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <>
            <div style={{display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap'}}>
                <span>Nou període:</span>
                <RangePicker
                    value={rang as any}
                    onChange={(v) => v && v[0] && v[1] && setRang([v[0], v[1]])}
                    format="DD/MM/YYYY"
                    placeholder={['Del', 'fins al']}
                    style={{width: 280}}
                />
                <Button title="Crear gestió" style={{backgroundColor: Colors.colors.color2, color: '#fff'}}
                        icon={<BiPlus/>} onClick={crearGestio}>Crear</Button>
                <Button title="Refrescar" style={{backgroundColor: Colors.colors.color4}}
                        icon={<BiRefresh/>} onClick={carregar}/>
            </div>

            <Table loading={loading} columns={columns} dataSource={gestions} rowKey="id" pagination={{pageSize: 20}}/>

            {/* Modal de validació producte a producte */}
            <Modal
                title="Validar lliuraments"
                open={validantId !== null}
                onCancel={() => setValidantId(null)}
                footer={[<Button key="close" onClick={() => setValidantId(null)}>Tancar</Button>]}
                width={800}
            >
                <p>Marca els ingredients lliurats (es descompta del stock automàticament):</p>
                <Table
                    loading={loadingProd}
                    dataSource={productes}
                    rowKey={(r) => `${r.id_ingredient}-${r.id_escola}`}
                    pagination={false}
                    size="small"
                    columns={[
                        {
                            key: 'lliurat', title: '', dataIndex: 'lliurat', width: 50,
                            render: (_, ele) => (
                                <Checkbox checked={ele.lliurat === 1} onChange={() => toggleLliurat(ele)}/>
                            )
                        },
                        {key: 'nom', title: 'Ingredient', dataIndex: 'nom'},
                        {
                            key: 'quantitat', title: 'Quantitat', dataIndex: 'quantitat', width: 120,
                            render: (v, ele) => <Tag color={Colors.colors.color4}>{v} {ele.mesura}</Tag>
                        },
                        {key: 'escola', title: 'Escola', dataIndex: 'escola'},
                    ]}
                />
            </Modal>
        </>
    );
};

// ============ PESTANYA 3: Comandes pendents de rebre ============
const ComandesPendents: React.FC = () => {
    const {page} = useContext(AuthContext);
    const [comandes, setComandes] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => { carregar(); /* eslint-disable-next-line */ }, []);

    async function carregar() {
        setLoading(true);
        setComandes(await GetComandesPendentsRebre(page));
        setLoading(false);
    }

    async function rebre(id: number) {
        const ok = await MoveComandaToStock(page, id);
        if (ok) { toast.success("Comanda rebuda i volcada al stock"); carregar(); }
        else toast.error("Error en rebre la comanda");
    }

    async function eliminar(id: number) {
        const ok = await DeleteComandaPendentRebre(page, id);
        if (ok) { toast.success("Comanda eliminada"); carregar(); }
        else toast.error("Error en eliminar");
    }

    const columns: ColumnsType<any> = [
        {key: 'id', title: 'ID', dataIndex: 'id', width: 60, sorter: (a, b) => a.id - b.id},
        {key: 'proveidor', title: 'Proveïdor', dataIndex: 'proveidor'},
        {
            key: 'inici', title: "Inici", dataIndex: 'inici', width: 130,
            render: (v) => <Tag>{v ? dayjs(v).format('DD-MM-YYYY') : '-'}</Tag>
        },
        {
            key: 'fin', title: 'Fin', dataIndex: 'fin', width: 130,
            render: (v) => <Tag>{v ? dayjs(v).format('DD-MM-YYYY') : '-'}</Tag>
        },
        {
            key: 'estat', title: 'Estat', dataIndex: 'estat', width: 140,
            render: (v) => v === 2
                ? <Tag color="green">Rebuda</Tag>
                : <Tag color="orange">Pendent de rebre</Tag>
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 180,
            render: (_, ele) => (
                <div style={{display: 'flex', gap: 6}}>
                    <Popconfirm title="Rebre comanda"
                                description="Es farà el volcat del stock al magatzem. Continuar?"
                                onConfirm={() => rebre(ele.id)}
                                icon={<QuestionCircleOutlined style={{color: 'green'}}/>}>
                        <Tooltip title="Marcar com rebuda (volcar al stock)">
                            <Button style={{backgroundColor: Colors.colors.color2, color: '#fff'}}
                                    icon={<BiDownArrowAlt/>}/>
                        </Tooltip>
                    </Popconfirm>
                    <Popconfirm title="Eliminar" description="Vols eliminar aquesta comanda pendent?"
                                onConfirm={() => eliminar(ele.id)}
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}>
                        <Button style={{backgroundColor: Colors.colors.color5}} icon={<BiTrash/>}/>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <>
            <div style={{display: 'flex', gap: 8, marginBottom: 12}}>
                <Button title="Refrescar" style={{backgroundColor: Colors.colors.color4}}
                        icon={<BiRefresh/>} onClick={carregar}/>
            </div>
            <Table loading={loading} columns={columns} dataSource={comandes} rowKey="id" pagination={{pageSize: 20}}/>
        </>
    );
};

// ============ CONTENIDOR PRINCIPAL AMB PESTANYES ============
const GestioStocks = () => {
    const titol = "Gestió de Stock";
    const {isLoggedIn, page} = useContext(AuthContext);

    if (!isLoggedIn) return <Login/>;

    const items = [
        {
            key: 'magatzem',
            label: <span><BsBoxSeam style={{marginRight: 6}}/>Stock Magatzem</span>,
            children: <StockMagatzem/>,
        },
        {
            key: 'lliurar',
            label: <span><BsTruck style={{marginRight: 6}}/>Comandes a lliurar (escoles)</span>,
            children: <ComandesLliurar/>,
        },
        {
            key: 'pendents',
            label: <span><BsInboxes style={{marginRight: 6}}/>Comandes pendents de rebre</span>,
            children: <ComandesPendents/>,
        },
    ];

    return (
        <div>
            <Toaster/>
            <NavBar/>
            <div className="general">
                <Card bordered className="elemento">
                    <h4 className="titol" style={{marginBottom: 16}}>{titol}</h4>
                    <Tabs defaultActiveKey="magatzem" items={items}/>
                </Card>
                <br/>
                <Historials pantalla="STOCK" pagina={page}/>
            </div>
        </div>
    );
};

export default GestioStocks;
